export default __webpack_public_path__ + "static/media/placeholder_dummy2016-yoga01-mobile-de.e8e66bc5.png";